import { render, staticRenderFns } from "./AllAttachementFileModal.vue?vue&type=template&id=60d53a91&scoped=true&"
import script from "./AllAttachementFileModal.vue?vue&type=script&lang=js&"
export * from "./AllAttachementFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AllAttachementFileModal.vue?vue&type=style&index=0&id=60d53a91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d53a91",
  null
  
)

export default component.exports